import { render, staticRenderFns } from "./ThePagesTable.vue?vue&type=template&id=fd065d64"
import script from "./ThePagesTable.vue?vue&type=script&lang=js"
export * from "./ThePagesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports